// src/services/contactService.ts

import axios from 'axios';
import { API_URL } from '../config/api.config';

/**
 * Interface pour les données du formulaire de contact
 */
export interface ContactFormData {
    name: string;
    email: string;
    subject: string;
    message: string;
}

/**
 * Service pour gérer les fonctionnalités de contact
 */
export const contactService = {
    /**
     * Envoie un email de contact directement via l'API principale
     * @param contactData - Les données du formulaire de contact
     * @returns Promesse résolue lorsque l'email est envoyé
     */
    sendContactEmail: async (contactData: ContactFormData): Promise<any> => {
        try {
            const response = await axios.post(`${API_URL}/auth/contact`, contactData);
            return response.data;
        } catch (error) {
            console.error('Error sending contact email:', error);
            throw new Error('Failed to send contact email');
        }
    }
};